<template>
    <div class="title">
        <div class="breadcrumb" v-if="hasBreadcrumbs">
            <ul>
                <li v-for="(page, idx) in lineageItems" :key="idx">
                    <router-link
                        :to="page.route"
                        class="btn btn-link has-icon-left">
                            <v-icon icon="caret-left"/>
                            <span>{{page.label}}</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="breadcrumb" v-else-if="history.length">
            <ul>
                <li v-for="(page, idx) in breadcrumbs" :key="idx">
                    <router-link
                        :to="page.route"
                        class="btn btn-link has-icon-left">
                        <v-icon icon="caret-left"/>
                        <span>{{page.label}}</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="title-control">
            <div class="title-heading" data-cy="title">
                <h1>
                    <slot/>
                </h1>
            </div>
            <div class="title-actions">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import vIcon from '@/components/form/v-icon';
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'v-title',
        components: {vIcon},
        props: {
            lineage: {
                type: Array,
                default: () => [],
            },
            breadcrumb: {
                type: Object,
                default: null,
            },
        },
        watch: {
            $route: {
                deep: true,
                immediate: true,
                handler(newRoute) {
                    if (this.breadcrumb && this.breadcrumb.root) {
                        this.updateHistory({
                            ...this.breadcrumb,
                            fullPath: newRoute.fullPath,
                        });
                    }
                },
            },
        },
        computed: {
            ...mapGetters({
                history: 'router/history',
            }),
            hasBreadcrumbs() {
                return this.lineage.length;
            },
            lineageItems() {
                return this.lineage.map((page) => {
                    const [label] = Object.keys(page);
                    const route = typeof page[label] === 'string' ? {name: page[label]} : page[label];
                    return {label, route};
                });
            },
            breadcrumbs() {
                const {fullPath} = this.$route;
                return this.history.filter(crumb => crumb.fullPath !== fullPath);
            },
        },
        methods: {
            ...mapActions({
                updateHistory: 'router/updateHistory',
            }),
        },
        created() {
            if (this.breadcrumb) {
                this.updateHistory({
                    ...this.breadcrumb,
                    fullPath: this.$route.fullPath,
                    meta: this.$route.meta,
                });
            }
        },
    };
</script>
